// import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import {
    initializeNavigation,
    initializeMobileToggle
} from './navigation.js';

window.$ = window.jQuery = $;

async function initializeWebsite() {
    await import('jquery.easing');
    await import('bootstrap/dist/js/bootstrap.js');
    await import('flexslider');

    // Navigatie afzonderlijk initialiseren
    $(function () {
        initializeNavigation();
        initializeMobileToggle();

        $(window).on('resize.changburiNav', () => {
            initializeNavigation();
        });
    });

    // Overige oorspronkelijke functionaliteit
    await import('./custom.js');

    // Impressiepagina initialiseren indien aanwezig
    if (document.querySelector('#unitegallery')) {
        const { initializeImpressie } = await import('./impressie.js');

        $(function () {
            initializeImpressie().catch(console.error);
        });
    }
}

initializeWebsite().catch(console.error);
